import { render } from "./StatisticsChart.vue?vue&type=template&id=7bdf69e6&ts=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=ts"
export * from "./StatisticsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__